import React from "react";

import { Menu, Button } from "@mantine/core";
import { withRouter } from "../utilities/withRouter";
import "./DropDownButton.css";
import { Flag } from "./Flag";
import { IconChevronDown } from "@tabler/icons-react";

class DropDownButton extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.redirect = this.redirect.bind(this);
	}
	redirect(href) {
		// history comes from routers withRouter method
		const { history } = this.props;

		history.push(href);
	}

	render() {
		const className = this.props.className || "RegularDropDown";
		const isIconDropDown = className.includes("IconDropDown");
		const isHollowButton = className.includes("HollowButton");

		let buttonVariant = "default";
		let buttonColor = undefined;
		if (isIconDropDown) buttonVariant = "subtle";
		else if (isHollowButton) buttonVariant = "transparent";
		if (this.props.color === "gold") {
			buttonVariant = "filled";
			buttonColor = "lw-gold";
		}

		// Collect upload items that need persistent file inputs outside the menu
		const uploadItems = this.props.menuItems
			.map((item, i) => (item ? { ...item, _index: i } : null))
			.filter(
				(item) =>
					item &&
					(item.type === "multi-file-upload" ||
						item.type === "single-upload" ||
						item.type === "multi-folder-upload")
			);

		return (
			<div className={"DropDownButton " + className}>
				{/* Hidden file inputs placed outside menu so they persist after menu closes */}
				{uploadItems.map((item) => {
					const inputId = `dropdown-upload-${item._index}`;
					const isMulti = item.type === "multi-file-upload";
					const isFolder = item.type === "multi-folder-upload";
					return (
						<input
							key={inputId}
							id={inputId}
							disabled={item.disabled}
							type="file"
							multiple={isMulti || isFolder}
							{...(isFolder
								? {
										webkitdirectory: "true",
										mozdirectory: "true",
										directory: "true",
									}
								: {})}
							style={{ display: "none" }}
							onChange={(event) => {
								const files = event.target.files;
								if (
									item.fileListChangeHandler &&
									files.length
								) {
									item.fileListChangeHandler(files);
								}
							}}
							accept={item.uploadAccept || "*"}
							onClick={(event) => {
								event.target.value = null;
							}}
						/>
					);
				})}
				<Menu
					position={this.props.dropup ? "top-start" : "bottom-start"}
				>
					<Menu.Target>
						<Button
							variant={buttonVariant}
							color={buttonColor}
							classNames={{ label: "DropDownButtonLabel" }}
							onClick={this.props.onOpen}
							disabled={this.props.disabled}
							leftSection={
								this.props.noIcon
									? null
									: this.props.iconComponent || null
							}
							rightSection={
								isIconDropDown ? undefined : (
									<IconChevronDown size={14} />
								)
							}
						>
							{this.props.title}
						</Button>
					</Menu.Target>
					<Menu.Dropdown
						style={{ maxHeight: "60vh", overflowY: "auto" }}
					>
						{this.props.menuItems.map((item, i) => {
							if (item) {
								if (item.divider) {
									return (
										<Menu.Divider
											key={"DIVID_" + Math.random()}
										/>
									);
								}
								if (item.href) {
									return (
										<Menu.Item
											onClick={() => {
												item.selectCallback &&
													item.selectCallback();
												this.redirect(item.href);
											}}
											disabled={item.disabled}
											key={i}
										>
											<div
												title={
													item.disabled
														? item.disabledHoverText
														: null
												}
											>
												{item.iconComponent ? (
													<>
														{item.iconComponent}
														<span
															style={{
																marginLeft: 8,
															}}
														>
															{item.text}
														</span>
													</>
												) : (
													<span>{item.text}</span>
												)}
											</div>
										</Menu.Item>
									);
								} else if (
									item.type === "multi-file-upload" ||
									item.type === "single-upload" ||
									item.type === "multi-folder-upload"
								) {
									return (
										<Menu.Item
											onClick={() => {
												var input =
													document.getElementById(
														`dropdown-upload-${i}`
													);
												input.click();
											}}
											key={i}
											disabled={item.disabled}
										>
											<div
												title={
													item.disabled
														? item.disabledHoverText
														: null
												}
											>
												{item.iconComponent && (
													<>
														{item.iconComponent}
														<span
															style={{
																marginLeft: 8,
															}}
														>
															{item.text}
														</span>
													</>
												)}
												{!item.iconComponent &&
													item.text}
											</div>
										</Menu.Item>
									);
								} else if (item.type === "userRegionFlag") {
									return (
										<Menu.Item key={i} disabled={true}>
											<div
												style={{
													cursor: "default",
													display: "flex",
													justifyContent:
														"space-around",
												}}
											>
												<Flag region={item.region} />

												<span
													style={{
														color: "rgb(51, 51, 51)",
													}}
												>
													{item.text}
												</span>
											</div>
										</Menu.Item>
									);
								} else if (item.type === "label") {
									return (
										<Menu.Item key={i} disabled={true}>
											<span
												style={{
													cursor: "default",
													color: "var(--lxw-button-text)",
												}}
											>
												{item.text}
											</span>
										</Menu.Item>
									);
								} else {
									return (
										<Menu.Item
											onClick={() => {
												item.onSelect();
											}}
											key={i}
											disabled={item.disabled}
											color={item.color}
										>
											{item.iconComponent ? (
												<div
													title={
														item.disabled
															? item.disabledHoverText
															: null
													}
												>
													{item.iconComponent}

													<span
														style={{
															marginLeft: 8,
														}}
													>
														{item.text}
													</span>
												</div>
											) : (
												<div
													title={
														item.disabled
															? item.disabledHoverText
															: null
													}
												>
													<span>{item.text}</span>
												</div>
											)}
										</Menu.Item>
									);
								}
							} else {
								return null;
							}
						})}
					</Menu.Dropdown>
				</Menu>
			</div>
		);
	}
}

const DropDownButtonWithRouter = withRouter(DropDownButton);
export { DropDownButton, DropDownButtonWithRouter };
